import React from "react";
import { Link as RouterLink } from "react-router";
import Link from "@mui/material/Link";

export default function InventoryRequestEmail({ inventoryRequest }) {
  const requestUser = inventoryRequest?.user;

  const accessLinkTitle = requestUser?.accessLink?.id
    ? requestUser.accessLink.name
      ? `${requestUser.accessLink.name}`
      : "Access link"
    : null;

  return (
    <>
      {accessLinkTitle ? (
        <Link
          component={RouterLink}
          to={`/settings/links/${requestUser.accessLink.id}/edit`}
          variant="body2"
        >
          {inventoryRequest.email || accessLinkTitle}
        </Link>
      ) : inventoryRequest.email ? (
        inventoryRequest.email
      ) : (
        <Link component={RouterLink} to={`/user/${requestUser.id}/edit`} variant="body2">
          {requestUser.email}
        </Link>
      )}
    </>
  );
}
